import {
    Body2,
    Flex,
    getIconByName,
    Heading3,
    IconTile,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { PathwayCardContent } from '../../../../configuration/shared';
import { ConditionalComponent } from '../../../utility/ConditionalComponent';

interface CardHeaderProps {
    content: PathwayCardContent;
    subHeading: string;
    testIdPrefix: string;
}

export const CardHeader = ({
    content,
    subHeading,
    testIdPrefix,
}: CardHeaderProps) => {
    const HeaderIcon = content.headerIcon
        ? getIconByName(content.headerIcon)
        : null;

    return (
        <Flex gap="sm">
            <ConditionalComponent condition={!!HeaderIcon}>
                <IconTile shape="squircle" size="xs" Icon={HeaderIcon!} />
            </ConditionalComponent>
            <Stack gap="xxxs" flex={1} data-testid={`${testIdPrefix}-title`}>
                <Heading3>{content.heading}</Heading3>
                {subHeading ? <Body2>{subHeading}</Body2> : null}
            </Stack>
        </Flex>
    );
};
